import { Dialog, DialogAction, DialogProps } from "../../core/components/dialog.js";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager.js";
import { SplittingAction, SplittingDialogResult } from "./util.js";
import { SelectionGrid } from "./selectionGrid.js";
import { ResultView } from "./resultView.js";
import { Assignment, SplitAssignmentActions, SplittingDialogWrapperStaticData } from "./splittingDialogTypes.js";
import { Helper } from "../../core/util/helper.js";
import { KeyValuePair, StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react";

enum SplittingDialogState {
    Selection, Result, Error
}

interface SplittingDialogWrapperProps {
    wrapperType: "window" | "dialog";
    splitAssignmentActions: SplitAssignmentActions[];

    staticData: SplittingDialogWrapperStaticData;

    markEvent?: (id: string) => void;
    onClose: (result: SplittingDialogResult) => void;
    onError: (error: any) => void;
}



interface SplittingDialogWrapperState {
    splittingResult: StringKeyDictionary<Assignment[]>;
    dialogState: SplittingDialogState;
    errorMessage: string;
    values: KeyValuePair<string, SplittingAction>[];
    dialogOpen: boolean;
}

export class SplittingWrapper extends React.Component<SplittingDialogWrapperProps, SplittingDialogWrapperState>{
    constructor(props: SplittingDialogWrapperProps) {
        super(props)

        this.state = {
            dialogOpen: true,
            errorMessage: null,
            dialogState: SplittingDialogState.Selection,
            values: props.splitAssignmentActions.map((assignmentAction) => {
                return {
                    Key: assignmentAction.Assignment.IsGuid,
                    Value: assignmentAction.DefaultAction
                };
            }),
            splittingResult: null
        }
    }

    private applySplitting = async (projNr: string, pIndex: number, cuttingEdge: string | Date, assignmentsToSplit: KeyValuePair<string, SplittingAction>[]) => {
        return new Promise<JsonResultClass>(async (resolve) => {
            const result = await HTTPService.post<JsonResultClass>("SplitEvents/SplitMultipleAssignments", {
                options: {
                    ProjNr: projNr,
                    PIndex: pIndex,
                    CuttingEdge: cuttingEdge,
                    AssignmentsToSplit: assignmentsToSplit
                }
            });
            resolve(result)
        });
    }

    private toggleDialog = () => {
        this.setState({ dialogOpen: !this.state.dialogOpen })
    }

    render() {
        let body = <></>;
        switch (this.state.dialogState) {
            case SplittingDialogState.Selection:
                const onChange = (id: string, value: SplittingAction) => {
                    const data = this.state.values;
                    const index = data.findIndex(item => item.Key == id);
                    data[index].Value = value;
                    this.setState({ values: data })
                }

                const onChangeAll = (data: KeyValuePair<string, SplittingAction>[]) => {
                    const updateData = data.filter((item) => {
                        const info = this.props.staticData.assignmentData[item.Key]
                        return Helper.hasValue(info);
                    });


                    this.setState({ values: updateData })
                }

                body = <SelectionGrid values={this.state.values} onChange={onChange} toggleDialog={this.toggleDialog} markEvent={this.props.markEvent} staticData={this.props.staticData} onChangeAll={onChangeAll} />
                break;
            case SplittingDialogState.Result:
                body = <ResultView resultData={this.state.splittingResult} staticData={this.props.staticData}/>;
                break;
            case SplittingDialogState.Error:
                body = <div>{this.state.errorMessage}</div>;
                break;

        }

        const props: WrapperProps = {
            onClose: this.props.onClose,
            applySplitting: async () => {
                const splittingAssignment = this.props.staticData.splittingAssignment;
                const result = await this.applySplitting(splittingAssignment.ProjNo, splittingAssignment.Index, splittingAssignment.StartActual, this.state.values);
                if (result.Code == 0) {
                    this.setState({ dialogState: SplittingDialogState.Result, splittingResult: result.Data.Assignments })
                } else {
                    this.setState({ dialogState: SplittingDialogState.Error, errorMessage: result.Message })
                }
            },
            dialogState: this.state.dialogState,
            open: this.state.dialogOpen,
            onError: (error) => {
                this.setState({ dialogOpen: false }, () => {
                    this.props.onError(error)
                })
            }
        };
        if (this.props.wrapperType === "window") {
            return (
                <WindowWrapper {...props}>
                    <div style={{ minHeight: "auto", width: "auto", maxHeight: "600px" }}>
                        {body}
                    </div>
                </WindowWrapper>
            );
        } else {
            return (
                <DialogWrapper {...props}>
                    <div style={{ minHeight: "auto", width: "1000px", maxHeight: "600px" }}>
                        {body}
                    </div>
                </DialogWrapper>
            );
        }
    }
}

// @ts-ignore
interface WrapperProps extends React.PropsWithChildren{
    onClose: (result: SplittingDialogResult) => void;
    dialogState: SplittingDialogState;
    applySplitting: () => Promise<void>;
    open: boolean;
    onError: (error: any) => void;
}

class WindowWrapper extends React.Component<WrapperProps, any>{
    private divRef: HTMLDivElement;
    private window: kendo.ui.Window;
    private id = kendo.guid();
    private readonly overlay: JQuery<HTMLElement>;

    constructor(props: WrapperProps) {
        super(props);
        this.overlay = $("<div>");
        this.state = {
        }
        $("body").append(this.overlay);
    }

    private renderButton = (title: string, actionId: string, cssClass: string) => {
        return (
            <button data-action-id={actionId} className={`splitting_window__footer__button ${cssClass}`}>
                {Helper.getTranslation(title)}
            </button>
        );
    }

    private renderFooter = () => {
        let buttons: JSX.Element[] = [];
        switch (this.props.dialogState) {
            case SplittingDialogState.Selection:
                buttons = [
                    this.renderButton("Standard.Abbrechen", "cancel", "splitting_window__footer__button--secundary"),
                    this.renderButton("WebSMS.ResourcePlanningScheduler.SplitAssignment.Apply", "apply", "splitting_window__footer__button--primary")
                ];
                break;
            case SplittingDialogState.Result:
                buttons = [
                    this.renderButton("Standard.CloseBtn", "success", "splitting_window__footer__button--primary")
                ];
                break;
            case SplittingDialogState.Error:
                buttons = [
                    this.renderButton("Standard.CloseBtn", "error", "splitting_window__footer__button--primary")
                ];
                break;
        }

        return (
            <div style={{ gridTemplateColumns: `repeat(${buttons.length}, 1fr)`}} className="splitting_window__footer">
                {buttons.map((btn, index) => {
                    return <div key={index} style={{ gridRow: "1/2", gridColumn: `${index + 1}/${index + 2}`, display: "flex" }}>{btn}</div>
                })}

            </div>
        );

    }

    private handleWindowOpeningState = () => {
        if (this.props.open) {
            this.window.open();
        } else {
            this.window.close();
        }
    }


    componentWillUnmount() {       
        this.window.destroy();
    }

    componentDidUpdate(prevProps: WrapperProps) {
        if (prevProps.open != this.props.open) {
            this.handleWindowOpeningState();
        }
    }

    componentDidMount() {
        const window = $(this.divRef);

        this.window = window.kendoWindow({
            width: "auto",
            title: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.SplitAssignment"),
            visible: false,
            close: () => {
                this.overlay.removeClass("unselectable")

            },
            open: () => {
                this.overlay.addClass("unselectable")
            }
        }).data("kendoWindow");

        this.window.center();
        this.handleWindowOpeningState();
        setTimeout(this.fixStyle, 0);
        setTimeout(this.fixOnClickEvents, 0);
    }

    private fixOnClickEvents = () => {
        const buttons = document.querySelectorAll(".splitting_window__footer__button");

        for (let i = 0; i < buttons.length; i++) {
            const button = buttons[i] as HTMLElement;
            const actionId = button.getAttribute("data-action-id");
            switch (actionId.toLowerCase()) {
                case "cancel":
                    button.onclick = () => {
                        this.props.onClose(SplittingDialogResult.Cancel);
                        this.window.close();
                    }
                    break;
                case "apply":
                    button.onclick = async () => {
                        this.activateLoadingScreen();
                        await this.props.applySplitting();
                        setTimeout(this.fixOnClickEvents, 0);
                        this.deactivateLoadingScreen();
                    }
                    break;
                case "success":
                    button.onclick = () => {
                        this.props.onClose(SplittingDialogResult.Success);
                        this.window.close();
                    }
                    break;
                case "error":
                    button.onclick = () => {
                        this.props.onClose(SplittingDialogResult.Error);
                        this.window.close();
                    }
                    break;
                    
            }
        }
    }

    componentDidCatch(error: any, _: any) {
        this.deactivateLoadingScreen();
        this.props.onError(error);
    }

    private activateLoadingScreen = () => {
        this.overlay.css("z-index", 1000999);
        this.overlay.css("display", "flex");
        this.overlay.css("justify-content", "center");
        this.overlay.css("align-items", "center");

        const i = $("<i>");
        i.addClass("fa-regular fa-spinner fa-3x");

        const div = $("<div>");
        div.addClass("spinner");
        div.css("height", "fit-content");
        div.css("width", "fit-content");

        div.append(i);

        this.overlay.append(div)
    }

    private deactivateLoadingScreen = () => {
        this.overlay.empty();
        this.overlay.css("z-index", 200);
    }

    private fixStyle = () => {
        const el = document.querySelector(`div#${this.id}`) as HTMLDivElement;
        el.style.padding = "0";
    }

    render() {
        return (
            <>
                <style>
                    {
                        `.splitting_window__footer{
                            height: 53px;
                            border-top: 1px solid rgb(201, 201, 201);
                            display: grid;
                            gap: 10px;
                            grid-template-rows: 1fr;
                            padding: 6px;
                        }
            
                        .splitting_window__footer__button{
                            height: 30px;
                            width: 100%;
                            align-self: center;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 16px;
                            height: 38px;
                            border-radius: 6px;
                            font-family: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
                        }

                        .splitting_window__footer__button--secundary{
                            background-color: #f0f0f0;
                            border: 1px solid #bdbdbd;    
                            cursor: pointer;
                        }

                        .splitting_window__footer__button--secundary:hover{
                            background-color: #c9c9c9;
                            border: 1px solid #c9c9c9;  
                        }

                        .splitting_window__footer__button--primary{
                            background-color: var( --primary-color);
                            border: 1px solid var(--secondary-color);
                            color: white;
                            cursor: pointer;
                        }

                        .splitting_window__footer__button--primary:hover{
                            background-color: var(--secondary-color);
                            border: 1px solid var(--secondary-color);
                        }`
                    }
                </style>
                <div ref={(ref) => { this.divRef = ref }} id={this.id}>
                    <div style={{ padding: "12px" }}>
                        {this.props.children}
                    </div>
                    {this.renderFooter()}
                </div>
            </>
        );
    }
}

class DialogWrapper extends React.Component<WrapperProps, any>{

    private getActions = (): Array<DialogAction> => {
        switch (this.props.dialogState) {
            case SplittingDialogState.Selection:
                return [
                    {
                        action: () => {
                            this.props.onClose(SplittingDialogResult.Cancel);
                        },
                        label: Helper.getTranslation("Standard.Ignore"),
                        primary: false,
                    },
                    {
                        action: () => {
                            this.props.applySplitting().then();
                            return false;
                        },
                        label: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.Apply"),
                        primary: true
                    }

                ];
            case SplittingDialogState.Result:
                return [
                    {
                        action: () => {
                            this.props.onClose(SplittingDialogResult.Success);
                        },
                        label: Helper.getTranslation("Standard.CloseBtn"),
                        primary: true
                    }
                ];
            case SplittingDialogState.Error:
                return [
                    {
                        action: () => {
                            this.props.onClose(SplittingDialogResult.Error);
                        },
                        label: "Close",
                        primary: true
                    }
                ];
        }
    }

    componentDidCatch(error: any, _: any) {
        this.props.onError(error);
    }

    render() {

        const dialogProps: DialogProps = {
            title: Helper.getTranslation("WebSMS.ResourcePlanningScheduler.SplitAssignment.SplitAssignment"),
            actions: this.getActions(),
            open: this.props.open
        };

        return (
            <Dialog {...dialogProps}>
                {this.props.children}
            </Dialog>
        )
    }
}